import "../css/footer.css"

export default function Footer(){
    return(
        <div id="footer" className="row">
            <p>Powered By : <a href="https://vmswebtech.in" target="_blank">VMSwebtech.in</a></p>
        </div>
    )
}